<template>
    <div>
        <label :for="context.name">{{LabelText}}</label>

        <input
            type='text'
            class="form-control"
            :id="context.name"
            :placeholder="placeholder"
            v-model="value"
            :minlength="contentLayer.personalized.min"
            :maxlength="contentLayer.personalized.max"
            :required="contentLayer.personalized.required"
            v-bind:class="{'is-invalid': InvalidInput}"
            @input="OnChangeINput"
            @click="ClickDeleteDefauld"
            @change="OnChangeBlurInput"
            @blur="OnChangeBlurInput" 
        />
        <p v-if="HelpText" class="form-help-text-input">{{HelpText}}</p>
        <ul class="form-errors-input">
            <li v-for="error in errors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default ({
    props: {
        context: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String,
            default(){
                return null
            }
        },
        maxlength: {
            type: String,
            default(){
                return null
            }
        },
        contentLayer: {
            type: Object,
            default(){
                return {}
            }
        },
        valueinput: {
            type: String,
            default(){
                return ''
            }
        }
    },
    data() {
        return {
            errors: [],
            value: null,
            HelpText: null,
            LabelText: null,
            InvalidInput: false
        }
    },
    computed: {
        count() {
            const Personalized = this.contentLayer.personalized
            if (Personalized.max) {
                return ` (${this.value.length}/${Personalized.max})`
            }
            return ''
        },
    },
    watch: {
        valueinput(v){
            this.value = v
        }
    },
    created(){

        const Personalized = this.contentLayer.personalized

        if(this.context.model){
            this.value = this.context.model
        }else{
            this.value = this.contentLayer.values[0].text
        }

        if(Personalized.help){
            this.HelpText = this.jsUcfirst(Personalized.help)
        }

        if(Personalized.max){
           if(Personalized.title){
                this.LabelText = this.jsUcfirst(Personalized.title + this.count)
            }else{
                this.LabelText = this.jsUcfirst(this.contentLayer.title + this.count)
            }
        }else{
            if(Personalized.title){
              this.LabelText = this.jsUcfirst(Personalized.title)
            }else{
              this.LabelText = this.jsUcfirst(this.contentLayer.title)
            }
        }
    },
    methods: {
        ...mapMutations([
            'setIsSaveLocalstorage'
        ]),
        jsUcfirst(string){
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        OnChangeBlurInput(v){
            const Personalized = this.contentLayer.personalized
            if(Personalized.required){
                if(!v.target.value){
                    if(Personalized.title){
                        this.errors.push(this.jsUcfirst(`${Personalized.title} is required.`));
                        this.InvalidInput = true
                    }else{
                        this.errors.push(this.jsUcfirst(`${this.contentLayer.title} is required`))
                        this.InvalidInput = true
                    }

                }
            }
            if(this.errors.length <= 0){
                this.setIsSaveLocalstorage(true);
                this.context.model = v.target.value
            }

        },
        ClickDeleteDefauld(e){
        if(e.target.value === this.contentLayer.values[0].text){
            e.target.value = ''
        }
        // e.target.select()
        },
        OnChangeINput(v){
            this.errors = []
            this.InvalidInput = false
            const Personalized = this.contentLayer.personalized
            if(Personalized.min){
                if(v.target.value.length < Personalized.min){
                    if(Personalized.title){
                        this.errors.push(this.jsUcfirst(`${Personalized.title} must be at least ${Personalized.min} characters long.`));
                        this.InvalidInput = true
                    }else{
                        this.errors.push(this.jsUcfirst(`${this.contentLayer.title} must be at least ${Personalized.min} characters long.`));
                        this.InvalidInput = true
                    }
                }
            }
            if(Personalized.max){
                if(v.target.value.length > Personalized.max){
                    if(Personalized.title){
                        this.errors.push(this.jsUcfirst(`${Personalized.title} must be less than or equal to ${Personalized.max} characters long.`));
                        this.InvalidInput = true
                    }else{
                        this.errors.push(this.jsUcfirst(`${this.contentLayer.title} must be less than or equal to ${Personalized.max} characters long.`));
                        this.InvalidInput = true
                    }
                }
            }
            if(Personalized.max){
                if(Personalized.title){
                    this.LabelText = this.jsUcfirst(Personalized.title + this.count)
                }else{
                    this.LabelText = this.jsUcfirst(this.contentLayer.title + this.count)
                }
            }
        }
    },
})
</script>

<style>
    ul.form-errors-input {
    list-style: none;
    margin: 0;
    padding: 0;
    color: coral;
    font-size: 14px;
    margin-top: 5px;
}
.form-help-text-input{
    color: #999;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/TextBlur.vue